import { SubmitHandlerWithDirtyFields } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { getGetChargingSessionsPaginatedDefaultValues } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/charging-sessions/get-charging-sessions-paginated.form-default-values';
import { GetChargingSessionsPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/charging-sessions/get-charging-sessions-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { Logger } from '@app/core/logger/logger';

import {
  FilterSearchEmspBoChargingSessionListContextProvider,
  useEmspBoChargingSessionListContext,
} from '../emsp-bo-charging-session.context';
import { EmspBoChargingSessionListFilterSearchFormController } from './emsp-bo-charging-session-list-filter-search-form/emsp-bo-charging-session-list-filter-search-form.controller';

interface EmspChargingSessionListFilterSearchControllerProps {
  onCancel: () => void;
  onSuccess: () => void;
}

export const EmspBoChargingSessionListFilterSearchController = ({
  onCancel,
  onSuccess,
}: EmspChargingSessionListFilterSearchControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const { getPaginatedQueryParameters, setGetPaginatedQueryParameters } =
    useEmspBoChargingSessionListContext();

  // HANDLERS //////////////////////////////////////////////////////////////////

  const handleError: SubmitErrorHandler<GetChargingSessionsPaginatedModel> = (
    errors,
  ) => {
    Logger.error(errors);
    toast.error(
      t('$.emsp-charging-session-list-filter-search.error', {
        error: t('global.unknown'),
      }),
    );
  };

  const handleSubmit: SubmitHandlerWithDirtyFields<
    GetChargingSessionsPaginatedModel
  > = (fieldValues) => {
    setGetPaginatedQueryParameters((current) => {
      return {
        ...current,
        textToSearch: fieldValues.textToSearch,
      };
    });
    onSuccess();
  };

  // RENDER ////////////////////////////////////////////////////////////////////

  const data = getGetChargingSessionsPaginatedDefaultValues(
    getPaginatedQueryParameters,
  );

  return (
    <FilterSearchEmspBoChargingSessionListContextProvider data={data}>
      <EmspBoChargingSessionListFilterSearchFormController
        onError={handleError}
        onSubmit={handleSubmit}
        onCancel={onCancel}
      />
    </FilterSearchEmspBoChargingSessionListContextProvider>
  );
};
